export default __webpack_public_path__ + "4ba768b28cde2b66530e4c140a5e3c30.jpg";